import { render, staticRenderFns } from "./PageAccessSchool.vue?vue&type=template&id=266f83a3&scoped=true&"
import script from "./PageAccessSchool.vue?vue&type=script&lang=js&"
export * from "./PageAccessSchool.vue?vue&type=script&lang=js&"
import style0 from "./PageAccessSchool.vue?vue&type=style&index=0&id=266f83a3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266f83a3",
  null
  
)

export default component.exports